export default "__VITE_ASSET__ovUnedHB__"